export enum EvergoCollections {
   ordersActivities = "orders-activities",
   orders = "orders",
}
